import React, { useRef, useEffect } from 'react';
import { styled } from 'styled-components';
import http from 'src/services/http';
import { MEDIA_WIDTHS } from '../theme/Theme';
import { Image } from 'antd';
import { ENVS, isMainnet } from 'src/configs/Configs.env';
import ImgNft1 from '../assets/nfts/nft-1.png';
import ImgNft2 from '../assets/nfts/nft-3.png';
import ImgNft3 from '../assets/nfts/nft-4.png';
import ImgNft4 from '../assets/nfts/nft-5.png';
import ImgRectangle from '../assets/nfts/rectangle.png';

const Wrapper = styled.div`
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
    .body {
        margin: auto;
        height: 100%;
        width: 100%;
        padding: 40px 20px;
        max-width: 1440px;
        .head-title {
            display: flex;
            align-items: center;
            text-decoration: underline 1px rgb(0, 0, 0);
            text-underline-offset: 7px;
            text-decoration-style: wavy;
        }
        .content {
            flex: 1;
            width: 100%;
            .large-title {
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 22px;
                line-height: 26px;
                letter-spacing: 0.24px;
                color: #000000;
                margin-left: 5px;
            }
            .box-content {
                width: 100%;
                height: 100%;
                margin-bottom: 12px;
                .nft-image {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 26px;
                    text-align: center;
                    color: white;
                    border-radius: 8px;
                }
                .nft-title {
                    font-family: 'Joystix';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                    color: #000000;
                    margin-top: 15px;
                }
            }
        }
        .content-row {
            margin-top: 20px;
            column-count: 4;
        }
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .body {
            .content-row {
                flex-direction: row;
                -webkit-column-count: 2; /* Chrome, Safari, Opera */
                -moz-column-count: 2; /* Firefox */
                column-count: 2;
                .small-title {
                    width: 100%;
                }
            }
        }
    }
`;

export const apiGetListNftRecents = async () => {
    let urlGetAssets = `${ENVS.REACT_APP_BASE_API}assets/?filter[id.sort]=desc&limit=4`;
    return http.get(urlGetAssets, {});
};

const RecentsMinted = () => {
    const [listNfts, setListNfts] = React.useState<any>([]);
    const onGetData = async () => {
        const listNftsResult: any = await apiGetListNftRecents();
        setListNfts(listNftsResult?.Items);
    };
    useEffect(() => {
        onGetData();
    }, []);

    if (listNfts.length === 0) {
        return <></>;
    }
    return (
        <Wrapper>
            <div className="body">
                <div className="content">
                    <div className="head-title">
                        <Image className="nft-image" preview={false} src={ImgRectangle} />
                        <p className="large-title">Recents minted</p>
                    </div>
                    <div className="content-row">
                        {listNfts.map((item: any, index: number) => {
                            return (
                                <div key={index} className="box-content">
                                    <Image className="nft-image" preview={false} src={item?.Image} />
                                    <p className="nft-title">{item?.Name}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default RecentsMinted;
